import { MethodsEnum } from "../enums/Methods.ts";
import { Hospital } from "../models/Hospital.ts";
import handleService from "./apiService.ts";

const create = async (hospital: Hospital) => {
  // id nunca deve ser enviado num cadastro novo - ver pacienteService.create para o motivo.
  const { id, ...hospitalSemId } = hospital as any;
  const result = await handleService({
    method: MethodsEnum.POST,
    endpoint: "/hospital",
    data: hospitalSemId,
  });
  return result;
};

const update = async (hospital) => {
  const result = await handleService({
    method: MethodsEnum.PATCH,
    endpoint: "/hospital/alterar",
    data: hospital,
  });
  return result;
};

const hospitalService = { create, update };

export default hospitalService;
